module.exports = {"id":"199262","name":"Kim Young Uk","rating":"74","photo":"./data/images/photos/0/199262.png","club":{"name":"Jeonnam Dragons","logo":"./data/images/clubs/JeonnamDragons.png"},"positions":["MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KimYoungUk0.json
// module id = 2385
// module chunks = 0